import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  CouponCover,
  CouponBody,
  TagWrapper,
  Title,
  SubTitle,
  ValueWrapper,
  Value,
  CutOut
} from './VoucherListView.style';

const TITLE_MAX_LINES = {
  TITLE_ONLY: 3,
  OTHER: 2
};

const VoucherListView = ({
  tag,
  cover,
  title,
  status,
  statusText,
  value,
  valueIcon,
  disabled,
  curveStyle
}) => {
  const titleMaxLines = useMemo(() => {
    return statusText !== undefined || value !== undefined
      ? TITLE_MAX_LINES.OTHER
      : TITLE_MAX_LINES.TITLE_ONLY;
  }, [statusText, value]);

  return (
    <Container curveStyle={curveStyle} disabled={disabled}>
      <CouponCover>
        {cover}
        {tag && <TagWrapper>{tag}</TagWrapper>}
      </CouponCover>

      <CouponBody>
        {/* this wrapper is to fix the spacing from overflow:hidden */}
        <div style={{ paddingBottom: 0 }}>
          <Title maxLines={titleMaxLines}>{title}</Title>
        </div>

        {statusText && (
          <SubTitle expiring={status === 'expiring'}>{statusText}</SubTitle>
        )}

        {value && (
          <ValueWrapper>
            {valueIcon}
            <Value>{value}</Value>
          </ValueWrapper>
        )}
      </CouponBody>
      <CutOut backgroundColor={curveStyle?.backgroundColor} />
    </Container>
  );
};

VoucherListView.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * voucher cover
   */
  cover: PropTypes.any.isRequired,
  /**
   * curve css styles
   */
  curveStyle: PropTypes.object,
  /**
   * if disabled
   */
  disabled: PropTypes.bool,
  /**
   * voucher status / type
   */
  status: PropTypes.oneOf(['default', 'expiring']),
  /**
   * subtitle in body
   */
  statusText: PropTypes.string,
  /**
   * tag
   */
  tag: PropTypes.any,
  /**
   * title in body
   */
  title: PropTypes.string.isRequired,
  /**
   * value text
   */
  value: PropTypes.string,
  /**
   * value icon
   */
  valueIcon: PropTypes.any
};

export default VoucherListView;
